import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
const forYou = ['Eres mamá y quieres estar más presente en la vida de tus hijos', 'Trabajas en servicios, limpieza, fábrica o cuidado de personas', 'Quieres un ingreso extra sin dejar tu trabajo actual', 'No tienes experiencia en negocios digitales — y eso está bien', 'Quieres que nadie sepa que tienes un negocio hasta que tú decidas', 'Tienes un teléfono o computadora y conexión a internet'];
const notForYou = ['Buscas hacerte millonaria sin hacer nada', 'No estás dispuesta a dedicar al menos 2-3 horas por semana', 'Ya lo intentaste todo y crees que nada puede funcionar para ti'];
const objections = [{
  q: '"No tengo tiempo para esto."',
  a: 'El tiempo no es el problema real. El problema es el miedo a invertir tiempo en algo que no funcione. Entendemos eso. Por eso el sistema está diseñado para que tu primer resultado llegue rápido — en días, no en meses. Una vez que ves que funciona, el tiempo aparece.'
}, {
  q: '"No soy buena con la tecnología."',
  a: 'Si sabes usar WhatsApp o Facebook, tienes todo lo que necesitas. Las herramientas que usamos son gratuitas y más simples de lo que imaginas. El manual te lleva de la mano, paso a paso, sin asumir que ya sabes nada.'
}, {
  q: '"¿Y si ya hay demasiada competencia?"',
  a: 'El mercado de educación hispana en EE.UU. crece cada año y hay más demanda que oferta. La clave no es ser la única — es estar en el lugar correcto con el producto correcto. Eso es exactamente lo que te enseñamos.'
}, {
  q: '"Ya intenté algo así antes y no funcionó."',
  a: 'Eso no significa que tú fallaste. Significa que el sistema anterior no era el correcto. Este es diferente porque está construido específicamente para el mercado hispano en EE.UU., con un producto que ya tiene demanda probada.'
}];
export function ObjectionsSection() {
  return <section style={{
    background: '#FAFAF6',
    padding: '80px 24px'
  }} data-id="element-65">
      <div style={{
      maxWidth: '1000px',
      margin: '0 auto'
    }} data-id="element-66">
        {/* For who */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} style={{
        marginBottom: '64px'
      }} data-id="element-67">
          <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 'clamp(24px, 3vw, 38px)',
          fontWeight: 700,
          color: '#1C1C1E',
          textAlign: 'center',
          marginBottom: '12px'
        }} data-id="element-68">
            ¿Esto es para ti?
          </h2>
          <p style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '16px',
          color: '#4A4A4A',
          textAlign: 'center',
          marginBottom: '36px',
          maxWidth: '500px',
          margin: '0 auto 36px'
        }} data-id="element-69">
            Sé honesta contigo misma. Si te identificas con la columna verde,
            este sistema fue hecho para ti.
          </p>
          <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '24px'
        }} data-id="element-70">
            <div style={{
            background: '#EAF4EE',
            borderRadius: '16px',
            padding: '28px 24px',
            border: '1px solid rgba(27,94,59,0.15)'
          }} data-id="element-71">
              <h3 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '18px',
              fontWeight: 700,
              color: '#1B5E3B',
              marginBottom: '20px'
            }} data-id="element-72">
                Es para ti si...
              </h3>
              <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }} data-id="element-73">
                {forYou.map((item, i) => <li key={i} style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                marginBottom: '12px',
                fontFamily: "'Lato', sans-serif",
                fontSize: '14px',
                color: '#1C1C1E',
                lineHeight: 1.6
              }} data-id="element-74">
                    <CheckCircle size={16} style={{
                  color: '#1B5E3B',
                  flexShrink: 0,
                  marginTop: '2px'
                }} data-id="element-75" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div style={{
            background: '#FFF8F8',
            borderRadius: '16px',
            padding: '28px 24px',
            border: '1px solid rgba(200,50,50,0.1)'
          }} data-id="element-76">
              <h3 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '18px',
              fontWeight: 700,
              color: '#8B2020',
              marginBottom: '20px'
            }} data-id="element-77">
                No es para ti si...
              </h3>
              <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }} data-id="element-78">
                {notForYou.map((item, i) => <li key={i} style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                marginBottom: '12px',
                fontFamily: "'Lato', sans-serif",
                fontSize: '14px',
                color: '#4A4A4A',
                lineHeight: 1.6
              }} data-id="element-79">
                    <XCircle size={16} style={{
                  color: '#C0392B',
                  flexShrink: 0,
                  marginTop: '2px'
                }} data-id="element-80" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Objection crushers */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-81">
          <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 'clamp(22px, 3vw, 34px)',
          fontWeight: 700,
          color: '#1C1C1E',
          textAlign: 'center',
          marginBottom: '12px'
        }} data-id="element-82">
            Lo que tu mente te está diciendo ahora mismo
          </h2>
          <p style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '15px',
          color: '#4A4A4A',
          textAlign: 'center',
          marginBottom: '36px',
          maxWidth: '480px',
          margin: '0 auto 36px'
        }} data-id="element-83">
            Esas voces que dicen "no puedo", "no es para mí", "ya lo intenté" —
            las conocemos. Y tenemos una respuesta para cada una.
          </p>
          <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '16px'
        }} data-id="element-84">
            {objections.map((obj, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} style={{
            background: '#fff',
            borderRadius: '14px',
            padding: '24px',
            boxShadow: '0 2px 16px rgba(28,28,30,0.06)',
            border: '1px solid #E8DDD0'
          }} data-id="element-85">
                <p style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '16px',
              fontWeight: 700,
              color: '#1C1C1E',
              marginBottom: '12px',
              fontStyle: 'italic'
            }} data-id="element-86">
                  {obj.q}
                </p>
                <p style={{
              fontFamily: "'Lato', sans-serif",
              fontSize: '14px',
              color: '#4A4A4A',
              lineHeight: 1.8,
              margin: 0
            }} data-id="element-87">
                  {obj.a}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}